import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ProductCategories, ProductCategoriesState } from "../../types/types";

const SLICE_NAME = "productCategories";

export const getProductCategories = createAsyncThunk<ProductCategories[]>(
  `${SLICE_NAME}/getProductCategories`,
  async (_, { rejectWithValue }) => {
    try {
      const API_URL = process.env.REACT_APP_URL_BACKEND;
      const response = await fetch(`${API_URL}/api/v1/product_categories/`);

      if (!response.ok) {
        throw new Error("Ошибка при загрузке категорий услуг");
      }

      return await response.json();
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue("Неизвестная ошибка при получении категорий услуг");
    }
  }
);

const initialState: ProductCategoriesState = {
  productCategories: [],
  loading: false,
  error: null,
};

const productCategoriesSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.productCategories = action.payload;
      })
      .addCase(getProductCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const selectProductCategories = (state: { productCategories: ProductCategoriesState }) =>
  state.productCategories.productCategories;

export default productCategoriesSlice.reducer;
